import MenuNavegacion from "@componentes/MenuNavegacion/MenuNavegacion";
import "./index.css";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
export default function Cabecera() {
  const [cabecera, setCabecera] = useState("/logo-magenta.png");

  useEffect(() => {
    // Cargar el config.json desde la carpeta public
    const loadConfig = async () => {
      try {
        const response = await fetch("/config.json");
        const config = await response.json();
        setCabecera(config.LOGO_AYUNTAMIENTO);
      } catch (error) {
        console.error("Error loading config:", error);
      }
    };

    loadConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="encabezado-main">
      <div className="encabezado">
        <div className="logos-izquierda">
          <Link className="link-cabecera" to="/">
            <img
              src="/Logotipo_Castilla-La_Mancha.png"
              className="encabezado-image grande"
              alt="Logo Castilla-La Mancha"
            />
            <img
              src={cabecera}
              className="encabezado-image pequeno"
              alt="Logo Ayuntamiento"
            />
          </Link>
        </div>

        <div className="menu-navegacion">
          <MenuNavegacion />
        </div>
        <div className="logos-derecha">
          <img
            src="/logo_ministerio.png"
            className="encabezado-image mediano"
            alt="Logo Ministerio"
          />
          <img
            src="/logo_recursos_humanos.png"
            className="encabezado-image grande-plus"
            alt="Logo Recursos Humanos"
          />
        </div>
      </div>
    </div>
  );
}
